import { axios, Response } from '..'

type Body = {
  oldPassword: string
  newPassword: string
}

const changePassword = (appUserId: number, body: Body): Response<null> => {
  return axios.put(`v1/users/${appUserId}`, body)
}

export default changePassword
